import type { RequestOrderCancelInput } from '@repo/api-contracts';
import { useInvalidateMyOrders } from '@/entities/order';
import { useInvalidateMyQuotes } from '@/entities/quote';
import { trpc } from '@/shared/api';

export interface UseRequestOrderCancelResult {
  /** 실패하면 서버 오류를 그대로 던진다 — 문구·상태 충돌 재조회는 취소 요청 대화상자가 맡는다. */
  readonly requestCancel: (input: RequestOrderCancelInput) => Promise<void>;
  readonly isPending: boolean;
}

/**
 * 결제 후 취소 요청(orders.requestCancel, 주문 설계 §6-1). 성공 응답(최신 상세)을 캐시에 넣고, 표시 이름('취소 요청됨')이
 * 바뀐 내 주문 목록과 견적 상세·목록(주문 표시 이름을 보여 준다)을 다시 불러온다.
 */
export const useRequestOrderCancel = (): UseRequestOrderCancelResult => {
  const orders = useInvalidateMyOrders();
  const quotes = useInvalidateMyQuotes();
  const mutation = trpc.orders.requestCancel.useMutation();

  const requestCancel = async (input: RequestOrderCancelInput): Promise<void> => {
    const order = await mutation.mutateAsync(input);
    orders.putDetail(order);
    await Promise.all([orders.list(), quotes.detail(order.quoteRequestId), quotes.list()]);
  };

  return { requestCancel, isPending: mutation.isPending };
};
